/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

define(['underscore', 'backbone', 'jquery'], function(_, Backbone, $) {

  function AttributeModel(el, prefix) {
    this.el = el;
    this.prefix = prefix || "";
  }

  function cloneRec(dest, src) {
    if (!src || !src.childNodes) return;
    for (var i = 0; i < src.childNodes.length; i++) {
      var node =  src.childNodes[i];
      var cloned = node.cloneNode(false);
      if (cloned.nodeName.toUpperCase() == "SCRIPT") {
        cloned.text = node.text;
      } else {
        cloneRec(cloned, node);
      }
      dest.appendChild(cloned);
    }
  }

  _.extend(AttributeModel.prototype, Backbone.Events, {
    has: function(name) {
      return this.get(name) != null;
    },

    get: function(name) {
      if (!name) {
        var res = {}
        for (var i = 0; i < this.el.attributes.length; ++i) {
          var attr = this.el.attributes[i];

          if (attr.name.length >= this.prefix.length &&
              attr.name.substring(0, this.prefix.length) == this.prefix) {
            res[attr.name.substring(this.prefix.length)] = attr.value;
          }
        }
        return res;
      }

      return this.el.getAttribute(this.prefix + name);
    },

    getCamelCase: function () {
      var transformed = {};

      _.each(this.get(), function (value, key) {
        var camelCaseKey = key.replace(/-(.)/g, function (wholeMatch, part) {
          return part.toUpperCase();
        });
        transformed[camelCaseKey] = value;
      });

      return transformed;
    },

    set: function(name, value, options) {
      var changed = false;

      options = options || {};
      if (options.unset) {
        if (this.el.hasAttribute(this.prefix + name)) {
          changed = true;
          this.el.removeAttribute(this.prefix + name);
        }
      }
      if (this.el.getAttribute(this.prefix + name) !== value) {
        changed = true;
        this.el.setAttribute(this.prefix + name, value);

      }
      if (changed) {
        this.trigger("change:" + name, this, value);
        this.trigger("change", this);
      }
    }

  });

  AttributeModel.camelCaseToSeparated = function (str) {
    return str && str.replace(/[A-Z]/g, function (wholeMatch, position) {
      return (position ? "-" : "") +wholeMatch.toLowerCase();
    });
  };

  function EmptyModel() {
  }

  _.extend(EmptyModel.prototype, Backbone.Events, {
    has: function(name) {
      return false;
    },

    get: function(name) {
      return null;
    },

    set: function(name, value) {
      return;
    }
  });

  var dom = {
    getAttributes: function (el) {
      var attributes = el.attributes,
          i = attributes.length,
          attribute, key, value,
          attrs = {};

      while (i--) {
        attribute = attributes[i];
        key = attribute.nodeName;
        value = attribute.nodeValue;
        attrs[key] = value;
      }

      return attrs;
    },

    insertAt: function (parentEl, el, position) {
      if (!parentEl) return;

      var nextSibling = parentEl.childNodes.length > position && parentEl.childNodes[position];
      if (nextSibling) {
        parentEl.insertBefore(el, nextSibling);
      } else {
        parentEl.appendChild(el);
      }
    },

    createStyleElement: function (css) {
      var el = document.createElement("style");

      el.setAttribute("type", "text/css");
      if (el.styleSheet) {
        el.styleSheet.cssText = css;
      } else {
        el.innerHTML = css;
      }

      return el;
    },

    updateScriptContent: function (el, content) {
      if (!el) return;

      if (el.text) {
        el.text = content;
      } else {
        el.innerHTML = content;
      }
    },

    isClipped: function (el) {
      if (!el) return false;
      return el.scrollWidth > el.offsetWidth;
    },

    // returns a dom element for the first element in the given html
    //   e.g. instantiate("<div>abc</div>") returns a dom node for the div
    instantiate: function (html) {
      if (!html) return;

      var tmp = $(html);

      if (tmp.length > 0) return tmp.get(0);
    },

    focus: function (el, keyboardOnly) {
      var $el = $(el),
          selector = dom.getFocusableSelector(keyboardOnly)

      if (selector) {
        if (!$el.is(selector)) {
          $el = $el.find(selector).first();
        }
      } else {
        $el = $el.find(dom.focusableElements()).filter(':visible').first()
      }

      if ($el.length) {
        $el.focus();
      }
    },
    focusableElements: function() {
      return 'a[href], area[href], input, select, textarea, button, iframe, object, embed, *[tabindex], *[contenteditable]';
    },

    getFocusableSelector: function (keyboardOnly) {
      var selector = "";
      if (!keyboardOnly) {
        return null;
      }

      selector += "[tabindex!=-1]";
      return selector;
    },

    focusable: function (el, keyboardOnly) {
      el = el || document.body;
      return $(el).find(dom.getFocusableSelector(keyboardOnly));
    },

    focusNextIfActive: function (el, keyboardOnly) {
      if (!el) return;

      var $el = $(el);

      if (el === document.activeElement || $el.find(document.activeElement).length) {
        dom.focusNext($el, keyboardOnly);
      }
    },

    focusNext: function (el, keyboardOnly) {
      if (!el) return;

      var $el = $(el),
          $focusable = dom.focusable(null, keyboardOnly),
          elLastFocusable;

      elLastFocusable = $el.find(dom.focusableElements()).last()[0];
      if (!elLastFocusable) {
        elLastFocusable = el;
      }
      var index = $focusable.index(elLastFocusable) + 1;
      if (index >= $focusable.length) {
        index = 0;
      }
      var toFocus = $focusable[index];
      window.setTimeout(function () {
        toFocus.focus();
      }, 0);
    },

    isChild: function (el, parentEl) {
      while (el && el !== document) {
        if (el === parentEl) return true;
        el = el.parentNode;
      }
      return false;
    },

    getMetaContentFromMetaName: function (name) {
      return $('meta[name="' + name + '"]').attr("content");
    },

    updateDateInputUI: function (value, filterId) {
      var datePickerInput = $('input.daterangepicker-input[name="' + filterId + '"]');
      datePickerInput.val(value);
    },

    updateSummerizedUI: function (searchModel) {
      var summarizeBy = searchModel.input.get('summarize_by');
      var summarizeByProperty = $('select[data-bind="summarize_by.property"]');
      var summarizeByOrder = $('select[data-bind="summarize_by.orderby"]');
      if ((!summarizeBy || !summarizeBy.property) && summarizeByProperty) {
        summarizeByProperty.val('');
      }
  
      if ((!summarizeBy || !summarizeBy.orderby) && summarizeByOrder) {
        summarizeByOrder.val('mes:relevance');
      }
    },

    AttributeModel: AttributeModel,
    EmptyModel: EmptyModel

  };

  return dom;
});
